import { defineManifest } from '@nw/contracts';

/** Browser-safe Library descriptor. Server registration lives in ./server. */
export const libraryManifest = defineManifest({
  id: 'library',
  version: '1.0.0',
  platformContract: '1',
  name: 'Library',
  description: 'Your books, shelves, reading and notes.',
  navigation: { label: 'Library', path: '/library', order: 10 },
  routes: ['/library', '/library/books/:id', '/library/books/:id/read', '/library/notes/:id'],
  collections: [
    'library_books',
    'library_shelves',
    'library_shelf_items',
    'library_reading_sessions',
    'library_reading_state',
    'library_notes',
  ],
  entityTypes: [
    {
      typeKey: 'library:book',
      label: 'Book',
      pluralLabel: 'Books',
      appearance: { color: '#E8C07A', shape: 'square' },
      routeTemplate: '/library/books/:id',
    },
    {
      typeKey: 'library:note',
      label: 'Book note',
      pluralLabel: 'Book notes',
      appearance: { color: '#9FD8C4', shape: 'hexagon' },
      routeTemplate: '/library/notes/:id',
    },
  ],
  predicates: [
    {
      id: 'library:authored_by',
      label: 'written by',
      inverseLabel: 'wrote',
      directed: true,
      from: ['library:book'],
      to: ['core:person'],
      allowManual: false,
    },
    {
      id: 'library:note_on',
      label: 'note on',
      inverseLabel: 'has note',
      directed: true,
      from: ['library:note'],
      to: ['library:book'],
      allowManual: false,
    },
  ],
  publicCapabilities: ['library.books.getSummary@1', 'library.books.findByTopics@1', 'library.reading.record@1'],
  requires: ['people.resolve@1', 'entities.preview@1'],
  optional: ['mind.concepts.search@1', 'integrations.bookMetadata.search@1'],
  contributions: ['navigation', 'search', 'home', 'entityPreviews', 'graph', 'export', 'quickCapture'],
  events: {
    emits: ['library.book.changed.v1', 'library.book.deleted.v1', 'library.reading.recorded.v1', 'library.note.changed.v1'],
    consumes: [],
  },
});
